import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loggedIn: false,
  user: {},
};

export const loginReducer = createSlice({
  name: "login",
  initialState,
  reducers: {
    login: (state) => {
      state.loggedIn = true;
    },
    logout: (state) => {
      state.loggedIn = false;
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { login, logout, setUser } = loginReducer.actions;
export const userSelector = (state) => state.login.user;
export const loginSelector = (state) => state.login.loggedIn;

export default loginReducer.reducer;
